import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();

  useEffect(() => {
    const hash = window.location.hash;
    const match = /session_id=([^&]+)/.exec(hash);
    const sid = match?.[1];
    if (!sid) { nav("/login"); return; }
    (async () => {
      try {
        await api.post("/auth/google/session", { session_id: sid });
        await refresh();
        nav("/dashboard", { replace: true });
      } catch { nav("/login"); }
    })();
    // eslint-disable-next-line
  }, []);

  return <div className="container-luxe py-32 text-center text-gray-500">Signing you in…</div>;
}
